const sanitize = (value: string) =>
  value
    .replace(/[^a-zA-Z0-9]+/g, '.')
    .replace(/\.+/g, '.')
    .replace(/^\.+|\.+$/g, '')
    .toLowerCase();

export function traceName(feature: string, action?: string) {
  const parts = ['ui', sanitize(feature)];
  if (action) {
    parts.push(sanitize(action));
  }
  return parts.filter(Boolean).join('.');
}

export function apiTraceName(path: string, method: string, action?: string) {
  const parts = ['api', sanitize(path), method.toLowerCase()];
  if (action) {
    parts.push(sanitize(action));
  }
  return parts.filter(Boolean).join('.');
}

